import decode from 'jwt-decode'
const MICROS = [
  'header',
  'login',
  'requests',
  'user',
  'shares',
  'profiles',
  'search',
  'cancer',
  'task'
]
const TASK_ROUTES = ['task']
const SEARCH_ROUTES = [
  'timeline',
  'records',
  'summary',
  'details',
  'upload',
  'shared',
  'home',
  'documentSearch'
]
const USER_MANAGEMENT_ROUTES = [
  'settings',
  'consents',
  'sharedwithme',
  'editUserInfo',
  'consentsettings'
]

const SHARED_PROFILE_ROUTES = ['s', 'shared', 'sharedRecords']
export function prefix(location, ...prefixes) {
  // Route to authenticate-user page, if url has token as query params
  const token = localStorage['default_auth_token']
  const params = new URLSearchParams(window.location.search)
  const path = window.location.pathname.split('/')

  if (token && window.location.pathname == '/') {
    const decodedToken = decode(token)
    const userId = decodedToken['https://ctz.nz/id']
    return (window.location.href = `/${userId}/home`)
  }

  const STANDALONE_PAGE = ['secure-upload', 'register']
  if (params.get('tkn') && STANDALONE_PAGE.find(page => window.location.href.includes(page))) {
    return prefixes.some(prefix => prefix === 'login')
  } else if (params.get('tkn') && !window.location.href.includes('/authenticate-user')) {
    return (window.location.href = `/authenticate-user/${window.location.search}`)
  } else if (params.get('token') && !window.location.href.includes('/authenticate-user')) {
    const path = window.location
    return (window.location.href = `${path.origin}/authenticate-user${path.pathname}${path.search}`)
  } else if (window.location.href.includes('/authenticate-user')) {
    return prefixes.some(prefix => prefix === 'login')
  } else if (
    params.get('utm_channel') &&
    params.get('utm_medium') &&
    !window.location.href.includes('/external-share')
  ) {
    const path = window.location
    return (window.location.href = `${path.origin}/external-share${path.pathname}${path.search}`)
  } else if (
    path.length > 2 &&
    path[1] === 's' &&
    !window.location.href.includes('/external-share') &&
    !window.location.href.includes('/cancer') &&
    !window.location.href.includes('/details') &&
    !window.location.href.includes('/shared')
  ) {
    const path = window.location
    return (window.location.href = `${path.origin}/external-share${path.pathname}${path.search}`)
  } else if (window.location.href.includes('/external-share')) {
    return prefixes.some(prefix => prefix === 'login')
  }
  //Route to login page incase of user not login
  if (
    !token &&
    !window.location.href.includes('/login') &&
    !window.location.href.includes('/forget-password') &&
    !window.location.href.includes('/register') &&
    !SHARED_PROFILE_ROUTES.some(r => location.pathname.split('/').includes(r))
  ) {
    return (window.location.href = '/login')
  }
  if (prefixes.includes('header')) {
    if (location.search.includes('header=false')) {
      return false
    }
    const nonHeaderPages = ['login', 'forget-password', 'register']
    return !nonHeaderPages.find(page => location.href.includes(page))
  }
  let pathname = location.pathname.split('/')
  /* Rendered micro should lead the route, this logic finds rendered micro based on that rule */
  let micro = ''
  for (const [index, path] of pathname.entries()) {
    if (MICROS.includes(path)) {
      micro = path
      break
    } else if (['forget-password', 'external-share', 'register'].includes(path)) {
      micro = 'login'
      break
    } else if (SEARCH_ROUTES.includes(path)) {
      micro = 'search'
      break
    } else if (USER_MANAGEMENT_ROUTES.includes(path)) {
      micro = 'user'
      break
    } else if (path === 's') {
      if (pathname.length > index + 1) {
        let nextPath = pathname[index + 1]
        if (['records', 'shared'].includes(nextPath)) {
          micro = 'search'
          break
        }
      }
      micro = 'cancer'
      break
    }
  }
  return prefixes.some(prefix => prefix === micro)
}

// The header is always active
export function header() {
  return prefix(location, 'header')
}

export function components() {
  if (checkLocationPath(location)) {
    return true
  } else {
    return location.pathname.includes('/home') || location.pathname.includes('/task/')
  }
}

export function auth() {
  return prefix(location, 'login')
}

export function requests(location) {
  if (checkLocationPath(location)) {
    return true
  } else {
    return prefix(location, 'requests')
  }
}

export function user(location) {
  if (checkLocationPath(location)) {
    return true
  } else {
    return prefix(location, 'user')
  }
}

export function sharing(location) {
  if (checkLocationPath(location)) {
    return true
  } else {
    return prefix(location, 'shares')
  }
}

export function profilePicker(location) {
  return prefix(location, 'profiles')
}

export function search(location) {
  if (checkLocationPath(location)) {
    return true
  } else {
    return prefix(location, 'search')
  }
}

export function cancer(location) {
  return prefix(location, 'cancer')
}

function checkLocationPath(location) {
  if (location.pathname.includes('userdata')) {
    return true
  }
}
